var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeart = function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M5.04 1.07a3.216 3.216 0 0 0-3.207 3.227c0 2.167 1.001 3.903 2.26 5.193 1.265 1.296 2.76 2.108 3.655 2.414l.005.002a.826.826 0 0 0 .247.031.826.826 0 0 0 .247-.031l.005-.002c.895-.306 2.39-1.118 3.655-2.414 1.26-1.29 2.26-3.026 2.26-5.193A3.216 3.216 0 0 0 10.96 1.07a3.186 3.186 0 0 0-2.558 1.292.5.5 0 0 1-.803 0A3.177 3.177 0 0 0 5.04 1.07ZM.833 4.297C.833 1.963 2.715.07 5.04.07 6.198.07 7.243.541 8 1.3A4.177 4.177 0 0 1 10.96.07c2.325 0 4.207 1.893 4.207 4.227 0 2.5-1.16 4.473-2.544 5.892-1.377 1.41-3.007 2.305-4.046 2.66a1.796 1.796 0 0 1-.577.088c-.185 0-.394-.023-.577-.088-1.038-.355-2.668-1.25-4.046-2.66C1.993 8.77.833 6.797.833 4.297Z",
    clipRule: "evenodd"
  })));
};
export default SvgIconHeart;